import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { View, Text, Image, TouchableOpacity } from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/native';
import { cartDisplay } from '../styles/cart';
import { detailsStyles } from '../styles/details';
import BackBtn from 'react-native-vector-icons/FontAwesome';
import DeleteBtn from 'react-native-vector-icons/Feather';
import PlusBtn from 'react-native-vector-icons/Feather';
import { Divider } from 'react-native-elements';
import { removeItem } from '../../Redux/actions';

const Cart = () => {
  const navigation = useNavigation();
  // const route = useRoute();

  const selectedItems = useSelector((state) => state.selectedItems);
  const dispatch = useDispatch();

  const tax = 0.16;
  const deliveryFee = 500;

  const subTotal = selectedItems.reduce((acc, item) => acc + item.price, 0);
  const taxAmount = subTotal * tax;
  const totalSum = subTotal + taxAmount + deliveryFee;

  const handleDeleteItem = (item) => {
    dispatch(removeItem(item));
  };

 const addOrder = () => {
   navigation.navigate('OrderNow');
 };
  const selectedRestaurant = selectedItems.length > 0 ? selectedItems[0] : null;

  return (
    <View style={cartDisplay.container}>
      <View style={detailsStyles.topIcon}>
        <BackBtn
          name="angle-left"
          style={detailsStyles.back}
          onPress={() => navigation.navigate('Home')}
        />
      </View>
      <Text style={cartDisplay.title}>Cart Items:</Text>

      {selectedItems.map((item, index) => (
        <View key={index} style={cartDisplay.itemContainer}>
          <Image
            source={item.image ? item.image : { uri: item.image_url }}
            style={cartDisplay.itemImage}
          />
          <Text style={cartDisplay.itemName}>
            {item.name ? item.name : item.genre}
          </Text>
          <View style={cartDisplay.itemDetails}>
            <Text style={cartDisplay.itemPrice}>Price: {item.price}</Text>
          </View>
          <View>
            <TouchableOpacity>
              <DeleteBtn
                name="x-circle"
                style={detailsStyles.heart}
                onPress={() => handleDeleteItem(item)}
              />
            </TouchableOpacity>
          </View>
        </View>
      ))}
      <View style={cartDisplay.add}>
        <PlusBtn
          name="plus-circle"
          style={detailsStyles.heart}
          onPress={() => navigation.navigate('Popup')}
        />
        <Text>Add Item </Text>
      </View>
      <Divider />
      <View style={cartDisplay.subContainer}>
        <View style={cartDisplay.sub}>
          <Text>Sub Total</Text>
          <Text>Ksh. {subTotal}</Text>
        </View>
        <Divider />
        <View style={cartDisplay.sub}>
          <Text>Tax ({tax * 100}%)</Text>
          <Text>Ksh. {taxAmount}</Text>
        </View>
        <Divider />
        <View style={cartDisplay.sub}>
          <Text>Delivery Fee</Text>
          <Text>Ksh. {deliveryFee}</Text>
        </View>
        <Divider />
        <View style={cartDisplay.sub}>
          <Text style={cartDisplay.total}>Total Sum: </Text>
          <Text style={cartDisplay.total}>Ksh. {totalSum}</Text>
        </View>
        <Divider />
      </View>
      <TouchableOpacity style={cartDisplay.button} onPress={addOrder}>
        <Text style={cartDisplay.buttonText}>Order Now</Text>
      </TouchableOpacity>
    </View>
  );
};

export default Cart;
